import "./Privacy.css"; 

const SubcriptionAgreement = () => {
    return (
        <div className="privacy-policy-container container py-5">
            <h1 className="text-center fw-bold mb-3">Subscription Agreement</h1>
            <p className="text-center text-muted mb-4"></p>
            <br></br>

            <section>
                <p>
                    This Subscription Agreement (the “Agreement”) is entered into as of the date of acceptance
                    (the “Effective Date”) by and between BooksComply (“Company”), and the subscribing
                    entity or individual identified in the subscription process (“Subscriber” or “You”). Company
                    and Subscriber may be referred to individually as a “Party” and collectively as the “Parties.”
                </p>

                <p>
                    <b>IMPORTANT: PLEASE READ THIS AGREEMENT CAREFULLY BEFORE USING
                        THE SERVICES.</b><br></br><br></br>
                    BY ACCESSING THE COMPANY’S PLATFORM, PURCHASING A SUBSCRIPTION,
                    OR USING THE SERVICES, YOU AGREE TO BE BOUND BY THE TERMS OF THIS
                    AGREEMENT. IF YOU DO NOT AGREE TO ALL OF THESE TERMS, YOU MUST
                    NOT ACCESS OR USE THE PLATFORM OR SERVICES.
                </p>
            </section>

            <section>
                <h2 className="section-title">1. Definitions</h2>
                <p>
                    For the purposes of this Agreement, the following terms have the meanings set forth below:
                </p>

                <ul className="privacy-list">
                    <li><b>“Platform”:</b> The Company’s online service available to Subscribers, including all
                        related applications, tools, updates, and subsequent versions released.</li>

                    <li><b>“Services”:</b> The subscription-based services provided by the Company through the
                        Platform, as specified in the applicable subscription plan. This may include but is not
                        limited to data analytics, content management, and software tools for specific
                        business functions.</li>

                    <li><b> “Subscription Fees”:</b>The recurring fees paid by Subscriber for access to the
                        Services. Fees may be based on the selected subscription plan, which could include
                        monthly, annual, or other payment structures.</li>

                    <li><b>“Authorized User”: </b>Any individual authorized by the Subscriber to access and use
                        the Services under this Agreement. Authorized users may include employees,
                        contractors, or affiliates of the Subscriber.</li>

                    <li><b>“Confidential Information”: </b>Any non-public information disclosed by either Party,
                        directly or indirectly, that is designated as confidential or would reasonably be
                        understood to be confidential given the nature of the information and the
                        circumstances of disclosure, including business plans, product information, customer
                        data, and proprietary software.</li>
                </ul>

            </section>

            <section>
                <h2 className="section-title">2. Grant of License and Restrictions</h2>
                <h4 className="section-subtitle">2.1 License</h4>
                <p>
                    Company grants Subscriber a limited, revocable, non-exclusive, non-transferable, and non-
                    sublicensable license to access and use the Platform and Services solely for Subscriber’s
                    internal business operations. The license does not permit any form of sub-licensing or
                    redistribution.
                </p>

                <h4 className="section-subtitle">2.2 Prohibited Uses</h4>
                <p>
                    Subscriber shall not:
                </p>
                <ul className="privacy-list">
                    <li>Copy, reproduce, distribute, or publicly display any portion of the Platform or
                        Services except as expressly permitted in this Agreement.</li>

                    <li>Modify, create derivative works from, or reverse-engineer the Platform or Services
                        without prior written consent from the Company.</li>

                    <li>Use the Platform to violate any laws, infringe on third-party rights, or for any
                        unlawful or unethical purpose.</li>

                    <li>Allow unauthorized third parties to access the Services or Platform, including by
                        sharing login credentials or bypassing access controls.</li>
                </ul>

            </section>

            <section>
                <h2 className="section-title">3. Subscription Term and Fees</h2>

                <h4 className="section-subtitle">3.1 Term</h4>
                <p>
                    This Agreement commences on the Effective Date and will continue for the initial
                    subscription period selected during the subscription process (the “Initial Term”). Unless
                    terminated in accordance with this Agreement, the subscription will automatically renew for
                    successive terms of equal length (each a “Renewal Term”). Renewal Terms will be governed
                    by the current pricing and terms in effect at the time of renewal.
                </p>

                <h4 className="section-subtitle">3.2 Fees</h4>
                <p>
                    Subscriber agrees to pay all applicable Subscription Fees, as outlined in the pricing plan
                    provided on the Platform. Fees are due in advance of the applicable term and are non-
                    refundable except as explicitly stated in this Agreement.
                </p>

                <h4 className="section-subtitle">3.3 Fee Adjustments</h4>
                <p>
                    Company reserves the right to adjust Subscription Fees at the beginning of any Renewal
                    Term. Any fee increase will be communicated to Subscriber at least 30 days before the
                    Renewal Term begins. Subscriber may choose to terminate the Agreement if the fee
                    adjustment is unacceptable.
                </p>

                <h4 className="section-subtitle">3.4 Late Payments</h4>
                <p>
                    If Subscriber fails to pay any Fees by the due date, Company may, at its discretion:
                </p>
                <ul className="privacy-list">
                    <li>Suspend access to the Services until payment is received.</li>

                    <li>Charge interest on overdue amounts at the lesser of 1.5% per month or the maximum
                        rate permitted by law.</li>
                </ul>

            </section>

            <section>
                <h2 className="section-title">4. Subscriber Responsibilities</h2>
                <h4 className="section-subtitle">4.1 Account Management</h4>
                <p>
                    Subscriber is responsible for maintaining the confidentiality of its account credentials and
                    ensuring that all information provided is accurate and up-to-date. Subscriber shall
                    immediately notify Company of any unauthorized access or breach of security related to the
                    account.
                </p>

                <h4 className="section-subtitle">4.2 Compliance</h4>
                <p>
                    Subscriber agrees to comply with all applicable laws, regulations, and third-party rights in
                    connection with its use of the Platform and Services. This includes respecting intellectual
                    property rights and ensuring that the Services are not used for fraudulent activities.
                </p>

                <h4 className="section-subtitle">4.3 System Requirements</h4>
                <p>
                    Subscriber is solely responsible for ensuring that its hardware, software, and internet
                    connection meet the minimum system requirements for accessing and using the Platform.
                    Company will not be liable for any issues resulting from Subscriber’s failure to meet these
                    requirements.
                </p>
            </section>

            <section>
                <h2 className="section-title">5. Confidentiality</h2>

                <h4 className="section-subtitle">5.1 Obligations</h4>
                <p>
                    Each Party agrees to protect the other Party’s Confidential Information with the same degree
                    of care it uses to protect its own confidential information, but no less than reasonable care.
                    This includes preventing unauthorized access, dissemination, or disclosure.
                </p>

                <h4 className="section-subtitle">5.2 Exceptions</h4>
                <p>
                    Confidential Information does not include information that is:
                </p>
                <ul className="privacy-list">
                    <li>Publicly available without breach of this Agreement.</li>

                    <li>Independently developed by the receiving Party without reference to the other Party’s
                        Confidential Information.</li>

                    <li>Required to be disclosed by law, government order, or court order, provided that the
                        disclosing Party is given prior notice and an opportunity to contest the disclosure.</li>
                </ul>
            </section>

            <section>
                <h2 className="section-title">6. Warranties and Disclaimers</h2>

                <h4 className="section-subtitle">6.1 Company Warranties</h4>
                <p>
                    Company represents and warrants that the Services will perform materially in accordance
                    with the documentation provided at the time of subscription. However, the performance may
                    vary depending on network conditions and Subscriber’s system setup.
                </p>

                <h4 className="section-subtitle">6.2 Disclaimer of Warranties</h4>
                <p>
                    EXCEPT AS EXPRESSLY PROVIDED, THE SERVICES ARE PROVIDED “AS IS”
                    WITHOUT WARRANTY OF ANY KIND. COMPANY DISCLAIMS ALL IMPLIED
                    WARRANTIES, INCLUDING BUT NOT LIMITED TO MERCHANTABILITY, FITNESS
                    FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
                </p>
            </section>

            <section>
                <h2 className="section-title">7. Limitation of Liability</h2>
                <p>
                    TO THE MAXIMUM EXTENT PERMITTED BY LAW:
                </p>
                <ul className="privacy-list">
                    <li>IN NO EVENT SHALL COMPANY BE LIABLE FOR ANY INDIRECT,
                        INCIDENTAL, OR CONSEQUENTIAL DAMAGES, INCLUDING BUT NOT
                        LIMITED TO LOST PROFITS, BUSINESS INTERRUPTION, OR DATA LOSS.</li>

                    <li>COMPANY’S TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT PAID
                        BY SUBSCRIBER DURING THE 12 MONTHS PRIOR TO THE CLAIM.</li>
                </ul>

                <h2 className="section-title">8. Indemnification</h2>
                <p>
                    Subscriber agrees to indemnify and hold harmless Company from any claims, damages, or
                    expenses arising out of Subscriber’s use of the Services, including any breach of this
                    Agreement, violation of third-party rights, or illegal activities conducted through the
                    Platform.
                </p>
            </section>

            <section>
                <h2 className="section-title">9. Termination</h2>

                <h4 className="section-subtitle">9.1 Termination by Subscriber</h4>
                <p>
                    Subscriber may terminate this Agreement at the end of the Initial Term or any Renewal Term
                    by providing written notice at least 30 days prior to the end of the applicable term.
                </p>

                <h4 className="section-subtitle">9.2 Termination by Company</h4>
                <p>
                    Company may terminate this Agreement or suspend Services if Subscriber fails to pay Fees,
                    breaches any material provision of this Agreement, or engages in unauthorized use of the
                    Platform.
                </p>

                <h2 className="section-subtitle">9.3 Effect of Termination</h2>
                <p>
                    Upon termination, Subscriber must immediately cease all use of the Platform and delete any
                    copies of related materials. No refunds will be issued for any remaining subscription period,
                    and Subscriber remains liable for any outstanding fees.
                </p>
            </section>

            <section>
                <h2 className="section-title">10. Miscellaneous.</h2>

                <h4 className="section-subtitle">10.1 Entire Agreement</h4>
                <p>
                    This Agreement constitutes the entire agreement between the Parties regarding its subject
                    matter and supersedes all prior agreements and understandings, whether written or oral.
                </p>

                <h4 className="section-subtitle">10.2 Notices</h4>
                <p>
                    All notices under this Agreement must be in writing and delivered to the addresses provided
                    during the subscription process or any updated addresses as notified in writing by either
                    Party.
                </p>

                <p>
                    This expanded version includes more detailed sub-sections and explanations, covering all
                    aspects of the subscription, user obligations, confidentiality, and limitations of liability.
                </p>
            </section>

        </div>
    );
};

export default SubcriptionAgreement;